import { persistSelectedBranchId } from './selectedBranch';

export const SELECTED_COMPANY_STORAGE_KEY = 'selectedCompanyId';
export const SELECTED_COMPANY_CHANGE_EVENT = 'selected-company-change';

const canUseWindow = () => typeof window !== 'undefined';

export const getSelectedCompanyId = () => {
  if (!canUseWindow()) return '';
  return String(window.localStorage.getItem(SELECTED_COMPANY_STORAGE_KEY) || '');
};

export const persistSelectedCompanyId = (companyId, { clearBranch = true } = {}) => {
  if (!canUseWindow()) return '';
  const previousCompanyId = getSelectedCompanyId();
  const nextCompanyId = String(companyId || '').trim();

  if (nextCompanyId) {
    window.localStorage.setItem(SELECTED_COMPANY_STORAGE_KEY, nextCompanyId);
  } else {
    window.localStorage.removeItem(SELECTED_COMPANY_STORAGE_KEY);
  }

  if (clearBranch && previousCompanyId !== nextCompanyId) {
    persistSelectedBranchId('');
  }

  window.dispatchEvent(new CustomEvent(SELECTED_COMPANY_CHANGE_EVENT, {
    detail: { companyId: nextCompanyId, previousCompanyId },
  }));
  return nextCompanyId;
};

export const clearSelectedCompanyContext = () => {
  const companyId = persistSelectedCompanyId('', { clearBranch: true });
  persistSelectedBranchId('');
  return companyId;
};

export const subscribeSelectedCompany = (handler) => {
  if (!canUseWindow() || typeof handler !== 'function') return () => {};

  const handleChange = (event) => {
    handler(String(event?.detail?.companyId || ''));
  };
  const handleStorage = (event) => {
    if (event.key !== SELECTED_COMPANY_STORAGE_KEY) return;
    persistSelectedBranchId('');
    handler(String(event.newValue || ''));
  };

  window.addEventListener(SELECTED_COMPANY_CHANGE_EVENT, handleChange);
  window.addEventListener('storage', handleStorage);
  return () => {
    window.removeEventListener(SELECTED_COMPANY_CHANGE_EVENT, handleChange);
    window.removeEventListener('storage', handleStorage);
  };
};
